import DOMPurify from 'dompurify';

export function openEmailPreview(htmlBody: string): void {
  const blob = new Blob([DOMPurify.sanitize(htmlBody)], { type: 'text/html' });
  const url = URL.createObjectURL(blob);
  const win = window.open(url, '_blank', 'noopener,noreferrer');
  win?.addEventListener('load', () => URL.revokeObjectURL(url));
}
